module.exports = __webpack_public_path__ + "93317d00.png";